var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ELEMENT } from './ELEMENT';
var SELECT = /** @class */ (function (_super) {
    __extends(SELECT, _super);
    function SELECT(props, options) {
        var _this = this;
        props = typeof props === 'string' ? { className: props } : props;
        var childNodes = options ? options.map(function (_a) {
            var text = _a.text, value = _a.value;
            return new OPTION({}, text, value);
        }) : [];
        _this = _super.call(this, 'SELECT', props, childNodes) || this;
        if (props.onChange) {
            _this.el.addEventListener('change', function () {
                if (typeof props !== 'string') {
                    var selected = _this.el.options[_this.el.selectedIndex];
                    var value = selected.getAttribute('value');
                    props.onChange(value, selected.text);
                }
            });
        }
        if (props.attrs && props.attrs.value) {
            var option = _this.el.querySelector("option[value=\"".concat(props.attrs.value, "\"]"));
            if (option)
                option.setAttribute('selected', 'selected');
        }
        if (props.value)
            setTimeout(function () { return _this.setValue(props.value); }, 1);
        return _this;
    }
    SELECT.prototype.setValue = function (value) {
        var selected = this.el.querySelector("option[selected=\"selected\"]");
        if (selected)
            selected.removeAttribute('selected');
        var option = this.el.querySelector("option[value=\"".concat(value, "\"]"));
        if (option) {
            this.el.selectedIndex = Array.from(this.el.childNodes).indexOf(option);
            option.setAttribute('selected', 'selected');
        }
        this.el.setAttribute('value', value);
    };
    return SELECT;
}(ELEMENT));
export { SELECT };
var OPTION = /** @class */ (function (_super) {
    __extends(OPTION, _super);
    function OPTION(props, text, value) {
        if (typeof props === 'string') {
            props = { className: props };
        }
        value = value || text;
        props.attrs = props.attrs ? __assign(__assign({}, props.attrs), { value: value }) : { value: value };
        return _super.call(this, 'OPTION', props, text) || this;
    }
    return OPTION;
}(ELEMENT));
